import categoriesReducer from './categoriesReducer';
import Categories from './categories';

export { categoriesReducer };

export * from './categoriesActions';

export default Categories;
